"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function getCurrentValue() {
    return typeof document === 'object'
        ? document.visibilityState === 'visible'
        : true;
}
function useIsAppActive(cb) {
    const [state, set] = (0, react_1.useState)(getCurrentValue);
    const cbRef = (0, react_1.useRef)(cb);
    (0, react_1.useEffect)(() => {
        function onVisibilityChange() {
            var _a;
            const next = getCurrentValue();
            set(next);
            (_a = cbRef.current) === null || _a === void 0 ? void 0 : _a.call(cbRef, next);
        }
        document.addEventListener('visibilitychange', onVisibilityChange);
        return function cleanupVisibilityListener() {
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);
    return state;
}
exports.default = useIsAppActive;
//# sourceMappingURL=useIsAppActive.js.map